/*
 * Copyright (c) 2018-2023 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */
import Grid from '@mui/material/Grid';
import { useEffect, useMemo, useState } from 'react';
import { useGetMemberTypesQuery } from 'store/api/version-api.slice';
import { getParameterByName } from 'utils';

import NavigationArrows from '../components/NavigationArrows';
import AddMemberTypes from './components/AddMemberTypes';
import EditMemberTypeDialog from './components/EditMemberTypeDialog';
import MemberTypesList from './components/MemberTypesList';
import { styles } from './styles/memberTypes.styles';

const MemberTypes = ({ handleNext, handlePrev, isNavigating }) => {
	const { data = {} } = useGetMemberTypesQuery();
	const memberTypes = useMemo(() => data.results || [], [data.results]);

	const [editableMemberType, setEditableMemberType] = useState();
	const [isEditOpen, setIsEditOpen] = useState(false);

	const handleCloseDialog = () => {
		setIsEditOpen(false);
	};

	useEffect(() => {
		document.title = 'Member Center - Onboarding - Member Types';

		window._hsq = window._hsq || [];

		const { _hsq } = window;

		_hsq.push(['setPath', '/onboarding-member-types']);
		_hsq.push(['trackPageView']);
		_hsq.push([
			'identify',
			{
				email: getParameterByName('email'),
				onboarding_stage: 'membertypes'
			}
		]);
	}, []);

	const isNextDisabled = !memberTypes?.length || isNavigating;

	return (
		<Grid container spacing={2} sx={styles.mainContainer}>
			<Grid item sm={6} xs={12}>
				<AddMemberTypes />
			</Grid>
			<Grid item sm={5} xs={12} sx={styles.memberTypesListWrapper}>
				<MemberTypesList setEditableMemberType={setEditableMemberType} setIsEditOpen={setIsEditOpen} />
			</Grid>
			<Grid sx={styles.actions}>
				<NavigationArrows
					handleNext={handleNext}
					handlePrev={handlePrev}
					isNextDisabled={isNextDisabled}
					isBackDisabled={isNavigating}
					isNavigating={isNavigating}
					hideBackButton
				/>
			</Grid>

			<EditMemberTypeDialog
				editableMemberType={editableMemberType}
				isOpen={isEditOpen}
				handleCloseDialog={handleCloseDialog}
			/>
		</Grid>
	);
};

export default MemberTypes;
